import {COMPONENT_TYPES} from '../../../../testkit/builders/constants'

export const quickActionBarMetaData = {
    mobileOnly: true,
    canContainByStructure: true,
    allowedChildTypes: [COMPONENT_TYPES.QUICK_ACTION_BAR_ITEM]
}
